import { createRootRoute, Outlet, useLocation } from '@tanstack/react-router'
import { AdminLayout } from '@/shared/ui'
import { ProtectedRoute } from '@/shared/components'

const RootComponent = () => {
  const location = useLocation()
  
  // Страница логина не должна использовать AdminLayout и защиту
  const isLoginPage = location.pathname === '/login'
  
  if (isLoginPage) {
    return (
      <div className="min-h-screen bg-gray-50">
        <Outlet />
      </div>
    )
  }

  // Все остальные страницы требуют авторизации
  return (
    <ProtectedRoute>
      <AdminLayout>
        <Outlet />
      </AdminLayout>
    </ProtectedRoute>
  )
}

export const Route = createRootRoute({
  component: RootComponent,
})
